import {
  createContext, useContext, useEffect, useState,
} from 'react';
import { useParams } from 'react-router-dom';

import { useAuth } from '../../../../store/auth';
import {
  SubCategory,
  SubCategoryStatisticDisplayMode,
} from '../../../../store/subCategory';
import { useCategoryById } from './useCategoryById';
import { useSubCategoryById } from './useSubCategoryById';
import { CategoryByIdData } from '../../../../store/category/byId';

export const CATEGORY_QUERY_KEY = 'category';
export const SUB_CATEGORY_QUERY_KEY = 'subCategory';

interface CategoryByIdContextProps {
  category: CategoryByIdData | null;
  subCategory: SubCategory | null;
  displayMode: SubCategoryStatisticDisplayMode;
  setDisplayMode: (mode: SubCategoryStatisticDisplayMode) => void;
  clearSelectedCategoryAndSubCategory: () => void;
}

const CategoryByIdContext = createContext<CategoryByIdContextProps | undefined>(
  undefined,
);

export const useCategoryByIdContext = () => {
  const context = useContext(CategoryByIdContext);

  if (!context) {
    throw new Error(
      'useCategoryByIdContext must be used within a CategoryByIdProvider',
    );
  }

  return context;
};

export function CategoryByIdProvider({ children }: React.PropsWithChildren) {
  const { categoryId, subCategoryId } = useParams();
  const { user } = useAuth();
  // const navigate = useNavigate();

  const {
    getCategoryById,
    clearCategoryById,
    response: category,
  } = useCategoryById();

  const {
    getSubCategoryById,
    clearSubCategoryById,
    response: subCategory,
  } = useSubCategoryById();

  const [displayMode, setDisplayMode] = useState<SubCategoryStatisticDisplayMode>('percent');

  useEffect(() => {
    if (categoryId) {
      getCategoryById({ id: categoryId });
    }
  }, [user, categoryId]);

  const clearSelectedCategoryAndSubCategory = () => {
    clearCategoryById();
    clearSubCategoryById();
  };

  useEffect(() => {
    if (!category) return;

    if (subCategoryId) {
      const isExistingSubCategory = category.subCategories.find(
        ({ id }) => id === subCategoryId,
      );

      if (isExistingSubCategory) {
        getSubCategoryById({ id: subCategoryId });
      }
      // TODO sumting wrong with this logic
      // else {
      //   const existingSubCategory = process.env
      //     .REACT_APP_DEFAULT_ACTIVE_SUB_CATEGORY_ID
      //     ? category.subCategories.find(
      //         ({ id }) =>
      //           id === process.env.REACT_APP_DEFAULT_ACTIVE_SUB_CATEGORY_ID
      //       ) || category.subCategories[0]
      //     : category.subCategories[0];

      //   navigate(`/categories/${category.id}/${existingSubCategory.id}`, {
      //     replace: true,
      //   });
      // }
    }
  }, [category, subCategoryId]);

  return (
    <CategoryByIdContext.Provider
      /* eslint-disable-next-line react/jsx-no-constructed-context-values */
      value={{
        category,
        subCategory,
        displayMode,
        setDisplayMode,
        clearSelectedCategoryAndSubCategory,
      }}
    >
      {children}
    </CategoryByIdContext.Provider>
  );
}
